export function combineUnevenArrays<T>(
  currentArr: T[] | undefined,
  initialArr: T[] | undefined,
): { current: T | undefined; original: T | undefined }[] {
  const currentLength = currentArr?.length ?? 0;
  const initialLength = initialArr?.length ?? 0;
  const largerArray = currentLength > initialLength ? currentArr : initialArr;
  return largerArray?.map((_, i) => ({ current: currentArr?.[i], original: initialArr?.[i] })) ?? [];
}
